import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 100);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Insurance Plans', path: '/insurance-plans' },
    { name: 'About Us', path: '/about' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
      } ${
        isScrolled
          ? 'bg-white shadow-lg py-4'
          : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center transition-colors ${
              isScrolled ? 'bg-secondary' : 'bg-secondary'
            }`}>
              <i className={`ri-shield-cross-line text-2xl transition-colors ${
                isScrolled ? 'text-white' : 'text-white'
              }`}></i>
            </div>
            <div className="flex flex-col">
              <span className={`font-heading text-xl font-bold whitespace-nowrap transition-colors ${
                isScrolled ? 'text-primary' : 'text-white'
              }`}>
                Dallas Health Insurance
              </span>
              <span className={`text-xs whitespace-nowrap transition-colors ${
                isScrolled ? 'text-darkGray' : 'text-lightBlue'
              }`}>
                Experts
              </span>
            </div>
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-secondary'
                      : 'text-secondary'
                    : isScrolled
                    ? 'text-primary hover:text-secondary'
                    : 'text-white hover:text-secondary'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <a
              href="tel:+12143060121"
              className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-secondary text-white hover:bg-secondary/90'
                  : 'bg-secondary text-white hover:bg-secondary/90'
              }`}
            >
              (214) 306-0121
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-primary' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-6 border-t border-lightBlue/20 pt-6">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`font-medium transition-colors cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-secondary'
                      : isScrolled
                      ? 'text-primary hover:text-secondary'
                      : 'text-white hover:text-secondary'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="tel:+12143060121"
                className="bg-secondary text-white px-6 py-3 rounded-lg font-semibold text-center hover:bg-secondary/90 transition-all whitespace-nowrap cursor-pointer"
              >
                (214) 306-0121
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}